import { t as trapFocus, r as removeTrapFocus } from './index-BIftRuJC.js';

if (!customElements.get('modal-window')) {
  customElements.define(
    'modal-window',
    class ModalWindow extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('[data-modal-trigger]');
        this.target = this.querySelector('[data-modal-target]');
        this.close = this.querySelectorAll('[data-modal-close]');
        this.modalWindow = this.querySelector('[data-modal-window]');
        this.body = this.closest('body');
        this.openedBy = null;

        this.trigger?.addEventListener('click', this.openModal.bind(this));

        if (this.id) {
          document.querySelectorAll(`[data-modal-open="${this.id}"]`).forEach((opener) => {
            opener.addEventListener('click', this.openModal.bind(this));
          });
        }

        this.close.forEach((button) => {
          button.addEventListener('click', this.closeModal.bind(this));
        });

        window.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isOpen) {
            this.closeModal();
          }
        });
      }

      get isOpen() {
        return !this.target.classList.contains('hidden');
      }

      openModal(event) {
        this.openedBy = event?.currentTarget || document.activeElement;
        this.target.classList.remove('hidden');
        this.body?.classList.add('modal-is-open');

        trapFocus({ container: this.modalWindow });
      }

      closeModal() {
        this.body?.classList.remove('modal-is-open');
        this.target.classList.add('hidden');

        removeTrapFocus(this.openedBy);
        this.openedBy = null;
      }
    }
  );
}
